@if (docId.includes(".pdf")) {
  <o-pdf [extraDocId]="docId"></o-pdf>
}
